import { differenceInDays } from "date-fns";
import { useNavigate } from "react-router-dom";
import { jt, t } from "ttag";

import { ROUTES } from "@/app/router";
import { useModalsDisplayStore, usePortalUserStore } from "@/app/stores";
import { Button, Dialog, HeartsIcon, StarFilledIcon } from "@/shared/ui";

const DAYS_BETWEEN_SHOWS = 10;

export const JourneySupportPromotionModal = () => {
  const { lastDateShown, timesShown, stopShowing } = useModalsDisplayStore(
    (state) => state.journeySupportPromotion,
  );
  const markJourneySupportPromotionAsSeen = useModalsDisplayStore(
    (state) => state.markJourneySupportPromotionAsSeen,
  );
  const showToUser = usePortalUserStore(
    (state) =>
      state.canAccessActiveWLFeaturesWithIntakeFormCompleted &&
      state.portalUser?.journeySupport?.canSchedule &&
      state.portalUser?.journeySupport?.firstTime &&
      !state.needsEmbeddablesInitialSync,
  );

  const isBlackFridayActive = usePortalUserStore(
    (state) => state.isBlackFridayActive,
  );

  const navigate = useNavigate();

  const TESTIMONIAL_QUOTES = [
    t`"This coaching helped me set realistic goals—and I hit my 10lb milestone two weeks early!"`,
    t`"I've done programs before, but this was the first time I felt like someone was really walking with me."`,
    t`"I didn't realize how helpful it would be just to talk to someone who gets it. I've stayed more motivated since our first session."`,
    t`"I thought I was plateauing, but my coach helped me make a small tweak that made a big difference."`,
  ] as const;

  const journeySupportStrong = (
    <strong key="journey-support-strong">{t`Journey support`}</strong>
  );

  const freeStrong = <strong key="free-strong">{t`free`}</strong>;

  const daysSinceLastShown = differenceInDays(new Date(), lastDateShown);

  const show =
    showToUser &&
    !stopShowing &&
    timesShown < TESTIMONIAL_QUOTES.length &&
    (timesShown === 0 || daysSinceLastShown >= DAYS_BETWEEN_SHOWS) &&
    !isBlackFridayActive;

  const handleNavigate = () => {
    markJourneySupportPromotionAsSeen();

    navigate(ROUTES.COACHING.JOURNEY_SUPPORT_SCHEDULE);
  };

  return (
    <Dialog.Root
      open={show}
      onOpenChange={() => markJourneySupportPromotionAsSeen()}
    >
      <Dialog.Content>
        <Dialog.Header icon={HeartsIcon}>
          <Dialog.Title>{t`Ready to team up? `}</Dialog.Title>
          <Dialog.Description>
            {jt`We're excited to introduce ${journeySupportStrong}, an exciting new feature offering personalized coaching with a Certified Medical Assistant to help you set goals, navigate challenges, and stay on track. It's an optional extra boost to keep you moving forward — you can book a ${freeStrong} session anytime!`}
          </Dialog.Description>
        </Dialog.Header>

        <div className="hidden flex-col items-center gap-2 border-t border-neutral-500 pt-4 text-center sm:flex">
          <div className="flex gap-2">
            {Array.from({ length: 5 }, (_, i) => (
              <StarFilledIcon key={i} className="size-4 text-neutral-500" />
            ))}
          </div>

          <p className="font-medium text-neutral-700">
            {TESTIMONIAL_QUOTES[timesShown]}
          </p>
        </div>

        <Dialog.Footer>
          <Button size="lg" onClick={handleNavigate}>
            {t`Book a session now!`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
